import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { COUNTRY } from "../../constants/CountryConstant";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { seletcEmployeePayroll } from "../../Redux/Slices/ProcessPayrollSlice";
import FormatCurrency from "../../SharedComponents/FormatCurrency";
import Utility from "../../utility/Utility";
import { DKLabel } from "deskera-ui-library";
import { FORMAT } from "../../constants/Constant";

const ProcessPayrollHeader = (props) => {

    const employeeProcessPayrollsData = useSelector(seletcEmployeePayroll);
    const [employeePayrollsData, setEmployeePayrollData] = useState(employeeProcessPayrollsData);
    const isContractor= props.isContractor === "true" || false;

    useEffect(() => {
        if (!Utility.isEmpty(employeeProcessPayrollsData)) {
            processPayrollUpdation();
            window.addEventListener('processDataUpdated', processPayrollUpdation);
        }
        return () => {
            window.removeEventListener('processDataUpdated', processPayrollUpdation);
        }
    }, [props]);

    const processPayrollUpdation = () => {
        setEmployeePayrollData(employeeProcessPayrollsData)
    }

    const isUSCompliance = TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US

    const getPayPeriod = (countryCode) => {
        switch (countryCode) {
            case COUNTRY.US:
                return(
                    <div className="column">
                        <DKLabel className="fw-m fs-xl" text={employeePayrollsData && employeePayrollsData.workPeriod ? Utility.formatDate(employeePayrollsData.workPeriod.from, FORMAT.MMDDYYYY_2) + ' - ' + Utility.formatDate(employeePayrollsData.workPeriod.to, FORMAT.MMDDYYYY_2) : ''} />
                        <p className="m-v-xs"> Pay Period</p>
                    </div>
                    )
            case "-1":
                return(
                    <div className="column">
                        <DKLabel className="fw-m fs-xl" text={employeePayrollsData && employeePayrollsData.workPeriod ? Utility.formatDate(employeePayrollsData.workPeriod.to, FORMAT.MMDDYYYY_2) : ''} />
                        <p className="m-v-xs"> Pay Day</p>
                    </div>
                    )
            default:
                return(
                <div className="column">
                    <DKLabel className="fw-m fs-xl" text={employeePayrollsData && employeePayrollsData.payDate ? Utility.formatDate(employeePayrollsData.payDate, FORMAT.MMDDYYYY_2) : ''} />
                    <p className="m-v-xs"> Payrun Date</p>
                </div>
                )
        }
    }

    return(
        <>
            {!isContractor && employeePayrollsData ? (
                <div className="parent-width">
                    <div className="row row-responsive mb-xxl">
                        <div className="column border-m bg-gray2 p-s" style={{ flexGrow: 1 }}>
                            <div className="column">
                                <FormatCurrency className="fw-m fs-xl" amount={employeePayrollsData.totalCost} />
                                <p className="m-v-xs"> Total Payroll Cost</p>
                            </div>
                        </div>
                        <div className="column border-m bg-gray2 p-s" style={{ flexGrow: 1 }}>
                            <div className="column">
                                <FormatCurrency className="fw-m fs-xl" amount={employeePayrollsData.totalEarnings} />
                                <p className="m-v-xs"> Employee Cost</p>
                            </div>
                        </div>
                        <div className="column border-m bg-gray2 p-s" style={{ flexGrow: 1 }}>
                            <div className="column">
                                <FormatCurrency className="fw-m fs-xl" amount={employeePayrollsData.totalEmployerCost} />
                                <p className="m-v-xs"> Employer Contribution</p>
                            </div>
                        </div>
                        <div className="column border-m bg-gray2 p-s" style={{ flexGrow: 1 }}>
                            {getPayPeriod(TenantService.get(TENANT.COUNTRY_CODE))}
                        </div>
                    </div>
                </div>
            ) : null
            }
            {isContractor && employeePayrollsData ? (
                <div className="parent-width">
                    <div className="row row-responsive mb-xxl">
                        <div className="row border-m bg-gray2 p-s">
                            <div className="column">
                                <FormatCurrency className="fw-m fs-xl" amount={employeePayrollsData.totalCost} />
                                <p className="m-v-xs"> Total Contractor Cost</p>
                            </div>
                        </div>
                        <div className="row border-m bg-gray2 p-s">
                            {getPayPeriod("-1")}
                        </div>
                        <div className="row border-m bg-gray2 p-s">
                            <div className="column">
                                <FormatCurrency className="fw-m fs-xl" amount={employeePayrollsData.totalEarnings} />
                                <p className="m-v-xs"> Additional Earnings</p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null
            }
        </>
    )
}

export default ProcessPayrollHeader